import './App.css'
import CommonRouts from './routes/CommonRoutes'

function App() {


  return (
    <>
      <CommonRouts />
    </>
  )
}

export default App
